import type {LinkTargetConcreteEntityType} from 'types';
import {Concept} from 'types';

/**
 * Entity type to use when configuring linking (link/move/copy) for a preview.
 *
 * A manifestation is previewed through its work (see WorkPreviewContent), and the
 * value loaded for the preview is the work metadata. Linking therefore targets the
 * work, so source configurations allowing work as target (e.g. copy from other work)
 * also apply when the preview was reached via a manifestation.
 */
export const getPreviewLinkingEntityType = (
  previewEntityType: LinkTargetConcreteEntityType,
): LinkTargetConcreteEntityType =>
  previewEntityType === Concept.manifestation
    ? Concept.work
    : previewEntityType;
